module.exports = __webpack_public_path__ + "static/concrete-finisher-3ac5e9f60ba9e1c33faf14b40e2af9da.jpg";